import { BaseComponent } from '@app/shared/components/base/base.component';
import { EventEmitter, Input, OnInit, Output, Directive } from '@angular/core';

@Directive()
export abstract class TwoWayBoundComponent<T extends any> extends BaseComponent
                                                          implements OnInit {

    @Input()
    public bananaBox: T;

    @Output()
    public bananaBoxChange = new EventEmitter<T>();

    public ngOnInit() {
        super.ngOnInit();
    }

    public onChange(): void {
        this.bananaBoxChange.emit(this.bananaBox);
    }
}
